export interface IFailAPIResponse {
  valid: boolean;
  message: any;
}

export function isFailAPIResponse(object: any): object is IFailAPIResponse {
  return true;
}
